const DefaultVariant = require('./default')
const show1Variant = require('./show1')
const show1InfiniteVariant = require('./show1-infinite')
const show1InfiniteFadeVariant = require('./show1-infinite-fade')
const show2Variant = require('./show2')
const show3Variant = require('./show3')
const show4Variant = require('./show4')
const mediaOnly = require('./media-only')
const mastheadStyle = require('./masthead-style')
const dashboardVariant = require('./dashboard')
const menuTabs = require('./menu-tabs')
const complimentaryPrivileges = require('./complimentary-privileges')
const bookingAddOns = require('./booking-add-ons')
const contained = require('./contained')
const onboarding = require('./onboarding')

const carousel = {
  [DefaultVariant.name]: DefaultVariant,
  [show1Variant.name]: show1Variant,
  [show1InfiniteVariant.name]: show1InfiniteVariant,
  [show1InfiniteFadeVariant.name]: show1InfiniteFadeVariant,
  [show2Variant.name]: show2Variant,
  [show3Variant.name]: show3Variant,
  [show4Variant.name]: show4Variant,
  [mediaOnly.name]: mediaOnly,
  [mastheadStyle.name]: mastheadStyle,
  [dashboardVariant.name]: dashboardVariant,
  [menuTabs.name]: menuTabs,
  [complimentaryPrivileges.name]: complimentaryPrivileges,
  [bookingAddOns.name]: bookingAddOns,
  [contained.name]: contained,
  [onboarding.name]: onboarding,
}

module.exports = {
  carousel
}
